module.exports = __webpack_public_path__ + "static/media/menu.579e1961.svg";